import React from 'react';
import ReferenceCard from './ReferenceCard';
import { filterProjectsByTags } from '@/config/references';
import { useTranslation } from '@/hooks/useTranslation';

interface ReferencesListProps {
  selectedTags: string[];
  searchTerm?: string;
}

const ReferencesList = ({ selectedTags, searchTerm }: ReferencesListProps) => {
  const { t } = useTranslation();
  
  // Filter references based on selected tags using the central config
  const filteredReferences = filterProjectsByTags(selectedTags, searchTerm);

  if (filteredReferences.length === 0) {
    return (
      <section className="py-20 bg-white">
        <div className="container text-center">
          <p className="text-xl text-gray-600">{t('referencesPage.search.noResults')}</p>
          <p className="mt-2 text-gray-500">{t('referencesPage.search.resetFilters')}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="grid grid-cols-1 gap-16 md:gap-24">
          {filteredReferences.map((reference, index) => (
            <div key={reference.id}>
              <ReferenceCard 
                reference={reference}
                isReversed={index % 2 !== 0}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReferencesList;
